import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './BasicInfoWrite.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';
import URL from "../../../../../constants/url";
import Modal from "../../../../../components/comm/Modal"

import ToastPopup from '../../../../../components/comm/ToastPopup';

const BasicInfoWrite = () => {

    const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const location = useLocation();
    const navigate = useNavigate();
    const mediInfo = location.state?.mediInfo;

    const [heightRaw, setHeightRaw] = useState(mediInfo.height.toString());
    const [bdwghRaw, setBdwghRaw] = useState(mediInfo.bdwgh.toString());

    const [isDisabled, setIsDisabled] = useState(true);

    const [saveMediInfo , setSaveMediInfo] = useState({
        id : mediInfo.id,
        usrInfoId : mediInfo.usrInfoId,
        height : mediInfo.height,
        bdwgh : mediInfo.bdwgh,
        prgncPsblAt : mediInfo.prgncPsblAt,
        inorgCntrAt : mediInfo.inorgCntrAt,
        bdpAbo : mediInfo.bdpAbo,
        bdpRh : mediInfo.bdpRh,
    });
    const [saveCompleteOpen, setSaveCompleteOpen] = useState(false);  //저장완료 모달

    const handleChangeNumber = (target) => {
        const { name, value } = target;
        const regex = /^\d{0,3}(\.\d{0,3})?$/;

        if (value === '' || regex.test(value)) {
            setSaveMediInfo((prev) => ({ ...prev, [name]: value }));
        }
    }

    const handleChangeRadio = (target) => {
        const { name, value } = target;
        setSaveMediInfo((prev) => ({ ...prev, [name]: value }));
    };

    const saveMediHlthInfo = useCallback(async () => {

        const url = "/mypage/saveMediHlthInfo";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: jToken,
            },
        }

        await axiosApi.post(url, saveMediInfo, reqOptions)
        // await axiosApi.post(url, saveMediInfo)
        .then((res) => { 
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setSaveCompleteOpen(true);
            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            console.error("내 의료정보 저장 중 오류 : ", err);
        })

    },[saveMediInfo])

    const handleClickSaveCompleteBtn = () => {
        setSaveCompleteOpen(false);
        navigate('/MyPageMain', { replace: true });
    }

    const PARTIAL_DECIMAL = /^(\d{0,3}(\.\d{0,1})?|\d{0,3}\.)$/;

    // 3) onChange: raw만 업데이트 (콤마를 점으로 통일)
    const handleChangeDecimal = (e) => {
        const { name, value } = e.target;
        let v = value.replace(',', '.');

        // const n = parseFloat(v);
        // if (!isNaN(n) && n > 999.9) v = '999.9';
        if (v === '' || PARTIAL_DECIMAL.test(v)) {
            if (name === 'height') setHeightRaw(v);
            if (name === 'bdwgh') setBdwghRaw(v);
        }
    };

    // 4) 확정 로직: 소수 3자리, 최대 999.999로 정규화
    const commitDecimal = (name, raw) => {
        if (!raw || raw === '.' ) return; // 빈 값/단독 점은 확정 X
        const [i, f = ''] = raw.split('.');
        const intPart = (i || '').slice(0, 3);
        // const fracPart = f.slice(0, 3);
        const fracPart = f.slice(0, 1); 
        const normalized = fracPart ? `${intPart}.${fracPart}` : intPart;
        // const num = Math.min(999.999, parseFloat(normalized));
        const num = Math.min(999.9, parseFloat(normalized));
        if (!isNaN(num)) {
            setSaveMediInfo(prev => ({ ...prev, [name]: num.toString() }));
        }
    };

    const isValidDecimal = (v) => /^\d{1,3}(\.\d{1,3})?$/.test(v) && parseFloat(v) <= 999.9;

    useEffect(() => {
        
        if(saveMediInfo.id === mediInfo.id &&
            saveMediInfo.usrInfoId === mediInfo.usrInfoId &&
            saveMediInfo.height === mediInfo.height &&
            saveMediInfo.bdwgh === mediInfo.bdwgh &&
            saveMediInfo.prgncPsblAt === mediInfo.prgncPsblAt &&
            saveMediInfo.inorgCntrAt === mediInfo.inorgCntrAt &&
            saveMediInfo.bdpAbo === mediInfo.bdpAbo &&
            saveMediInfo.bdpRh === mediInfo.bdpRh 
        ) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }


    },[saveMediInfo])

    if(!mediInfo) return;
    

    return (
        <>
            <HeadSub title="기본 정보"/>
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style['record-writebox']}>
                        <div>
                            <p>키</p>
                            <div className='input-box' data-type='c'>
                                    {/* <input type="number" name="height" id="height" placeholder='170' value={saveMediInfo.height} onChange={(e) => handleChangeNumber(e.target)}/> */}
                                    <input
                                        type="text"
                                        inputMode="decimal"
                                        name="height"
                                        placeholder="---"
                                        value={heightRaw}
                                        onChange={handleChangeDecimal}
                                        onBlur={() => commitDecimal('height', heightRaw)}
                                    />
                                    <span className='unit'>cm</span>
                             </div>
                        </div>
                        <div>
                            <p>체중</p>
                            <div className='input-box' data-type='c'>
                                    {/* <input type="number" name="bdwgh" id="bdwgh" placeholder='64' value={saveMediInfo.bdwgh} onChange={(e) => handleChangeNumber(e.target)}/> */}
                                    <input
                                        type="text"
                                        inputMode="decimal"
                                        name="bdwgh"
                                        placeholder="---"
                                        value={bdwghRaw}
                                        onChange={handleChangeDecimal}
                                        onBlur={() => commitDecimal('bdwgh', bdwghRaw)}
                                    />
                                    <span className='unit'>kg</span>
                             </div>
                        </div>
                        <div className={style['mid-txt']}>
                            <div className={style['select-list-box']}>
                                <p>ABO</p>                
                                <ul data-layout="2x2">
                                    <li>
                                        <div className='radio-selectbox'>
                                            <input type="radio" id="bloodType-select1" name='bdpAbo' value={'A'} checked={saveMediInfo.bdpAbo === 'A'} onChange={(e) => handleChangeRadio(e.target)}/>
                                            <label htmlFor="bloodType-select1">
                                                <span>A</span>
                                            </label>
                                        </div>  
                                    </li>
                                    <li>
                                        <div className='radio-selectbox'>
                                            <input type="radio" id="bloodType-select2" name='bdpAbo' value={'B'} checked={saveMediInfo.bdpAbo === 'B'} onChange={(e) => handleChangeRadio(e.target)}/>
                                            <label htmlFor="bloodType-select2">
                                                <span>B</span>
                                            </label>
                                        </div>  
                                    </li>
                                    <li>
                                        <div className='radio-selectbox'>
                                            <input type="radio" id="bloodType-select3" name='bdpAbo' value={'O'} checked={saveMediInfo.bdpAbo === 'O'} onChange={(e) => handleChangeRadio(e.target)}/>
                                            <label htmlFor="bloodType-select3">
                                                <span>O</span>
                                            </label>
                                        </div>  
                                    </li>
                                    <li>
                                        <div className='radio-selectbox'>
                                            <input type="radio" id="bloodType-select4" name='bdpAbo' value={'AB'} checked={saveMediInfo.bdpAbo === 'AB'} onChange={(e) => handleChangeRadio(e.target)}/>
                                            <label htmlFor="bloodType-select4">
                                                <span>AB</span>
                                            </label>
                                        </div>  
                                    </li>
                                </ul>
                            </div>

                            <div className={style['select-list-box']}>
                                <p>RH</p>                
                                <ul data-layout="2x2">
                                    <li>
                                        <div className='radio-selectbox'>
                                            <input type="radio" id="rh-select1" name='bdpRh' value={'RH+'} checked={saveMediInfo.bdpRh === 'RH+'} onChange={(e) => handleChangeRadio(e.target)}/>
                                            <label htmlFor="rh-select1">
                                                <span>RH+</span>
                                            </label>
                                        </div>  
                                    </li>
                                    <li>
                                        <div className='radio-selectbox'>
                                            <input type="radio" id="rh-select2" name='bdpRh' value={'RH-'} checked={saveMediInfo.bdpRh === 'RH-'} onChange={(e) => handleChangeRadio(e.target)}/>
                                            <label htmlFor="rh-select2">
                                                <span>RH-</span>
                                            </label>
                                        </div>  
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {loginUser.gendr !== '1' && 
                        <div className={style['select-list-box']}>
                            <p>임신가능성</p>
                            <ul>
                                <li>
                                    <div className='radio-selectbox'>
                                        <input type="radio" id="prgncPsblAt-select1" name='prgncPsblAt' value={'1'} checked={saveMediInfo.prgncPsblAt === '1'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="prgncPsblAt-select1">
                                            <span>있음</span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div className='radio-selectbox'>
                                        <input type="radio" id="prgncPsblAt-select2" name='prgncPsblAt' value={'0'} checked={saveMediInfo.prgncPsblAt === '0'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="prgncPsblAt-select2">
                                            <span>없음</span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div className='radio-selectbox'>
                                        <input type="radio" id="prgncPsblAt-select3" name='prgncPsblAt' value={'2'} checked={saveMediInfo.prgncPsblAt === '2'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="prgncPsblAt-select3">
                                            <span>현재 임신중입니다</span>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        }

                        <div className={style['select-list-box']}>
                            <p>장기기증자</p>
                            <ul>
                                <li>
                                    <div className='radio-selectbox'>
                                        <input type="radio" id="inorgCntrAt-select1" name='inorgCntrAt' value={'1'} checked={saveMediInfo.inorgCntrAt === '1'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="inorgCntrAt-select1">
                                            <span>해당</span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div className='radio-selectbox'>
                                        <input type="radio" id="inorgCntrAt-select2" name='inorgCntrAt' value={'0'} checked={saveMediInfo.inorgCntrAt === '0'} onChange={(e) => handleChangeRadio(e.target)}/>
                                        <label htmlFor="inorgCntrAt-select2">
                                            <span>미해당</span>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>


                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                            <div className="inner-box">
                                <div className='btn-layout' data-btn-num="1">
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={saveMediHlthInfo} disabled={isDisabled}>
                                        <span>수정 완료</span>
                                    </button>
                                </div>
                            </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}

                </div>
                <Modal isOpen={saveCompleteOpen} setIsOpen={handleClickSaveCompleteBtn}>
                    <div className='modal-box' data-type="b">
                        <div className='modal-top-box'>
                            <div className='sub-box'>
                                <span>기본정보 수정이 완료되었습니다.</span>
                            </div>
                        </div>
                        <div className="modal-bottom-box">                                
                            <div className='btn-layout'>
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={handleClickSaveCompleteBtn}>
                                    <span>확인</span>
                                </button>
                            </div> 
                        </div>
                    </div>    
                </Modal>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default BasicInfoWrite;
